import { Button, Spin } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCommentsAction,
  setMaxPage,
  setPage,
} from '../../../actions/commentsActions/commentsActions';
import { subscribe } from '../../../helpers/events';
import cn from 'classnames';
import styles from './LastComment.module.scss';
import { cutOffOddCharacters } from './utils/cutOffOddCharacters';

const LastComment = ({
  onClick,
  entityId,
  setEntityIdAction,
  getEntityCommentsAction,
  getLastComment,
  withBorder = true,
  withTitle = false,
}) => {
  const dispatch = useDispatch();
  const comments = useSelector(
    (state) => state.commentsChatStore.comments.data
  );
  const [lastComment, setLastComment] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchLastComment = useCallback(async () => {
    setIsLoading(true);

    const lastComment = await getLastComment(entityId);

    setLastComment(lastComment);

    setIsLoading(false);
  }, [entityId, getLastComment]);

  useEffect(() => {
    fetchLastComment();
  }, [fetchLastComment, comments]);

  useEffect(() => {
    return subscribe('chatAttachmentDeleted', (data) => {
      if (data.parentId === entityId) {
        getLastComment();
      }
    });
  }, [entityId]);

  const clickOpenComments = useCallback(() => {
    dispatch(setMaxPage(lastComment.maxPage));
    dispatch(setPage(0));
    dispatch(setEntityIdAction(entityId));
    dispatch(setCommentsAction([]));
    dispatch(getEntityCommentsAction(entityId));
    onClick();
  }, [entityId]);

  const lastCommentMessage = useMemo(() => {
    if (lastComment?.note) {
      return lastComment.note;
    } else if (!lastComment?.note && lastComment?.amount) {
      return '(Вложения)';
    }
  }, [lastComment]);

  return (
    <Spin spinning={isLoading}>
      <div className={cn(styles.lastComment, {
        [styles.border]: withBorder
      })}>
        {withTitle && (
          <h4 className={styles.title}>Комментарии</h4>
        )}
        {lastComment?.note ? (
          <>
            <div className={styles.lastCommentHeader}>
              <div>
                {lastComment.operationDate &&
                  moment(lastComment.operationDate).format('DD-MM-YYYY HH:mm')}
              </div>
              <div>
                {lastComment.firstName &&
                  lastComment.surName &&
                  `${lastComment.firstName} ${lastComment.surName}`}
              </div>
            </div>
            <div className={styles.lastCommentMessage}>
              {cutOffOddCharacters(lastCommentMessage)}
            </div>
            <Button
              className={styles.showAllCommentsButton}
              onClick={clickOpenComments}
            >
              Показать все комментарии{' '}
              {lastComment.amount && `(${lastComment.amount})`}
            </Button>
          </>
        ) : (
          <>
            <div>Комментариев пока нет. Будьте первыми!</div>
            <Button
              className={styles.showAllCommentsButton}
              onClick={clickOpenComments}
            >
              Комментарии
            </Button>
          </>
        )}
      </div>
    </Spin>
  );
};

export default LastComment;
